import { baseUrl } from "../utils/baseUrl";
import jwtInterceptor from "./autorizacao/jwt-interceptor";

class ServicosAtribuicaoMilhas {
    create(atribuicao) {
        return jwtInterceptor.post(`${baseUrl}/atribuicaoMilhas`, atribuicao)
    }
    createAtribuicaoDinamica(atribuicao) {
        return jwtInterceptor.post(`${baseUrl}/atribuicaoMilhas/dinamico`, atribuicao)
    }
    listarTodos() {
        return jwtInterceptor.get(`${baseUrl}/atribuicaoMilhas`)
    }
    editar(id, atribuicao) {
        return jwtInterceptor.put(`${baseUrl}/atribuicaoMilhas/${id}`, atribuicao)
    }
    deletar(id) {
        return jwtInterceptor.delete(`${baseUrl}/atribuicaoMilhas/${id}`)
    }
    listarPorIdColaborador(id) {
        return jwtInterceptor.get(`${baseUrl}/atribuicaoMilhas/listaId/${id}`)
    }
}

export default new ServicosAtribuicaoMilhas();